import React from 'react';
import { AuthProvider } from './AuthContext';
import { TransactionProvider } from './TransactionContext';
import { NotificationProvider } from './NotificationContext';
import { TrackingProvider } from './TrackingContext';
import { UIProvider } from './UIContext';

// AppContext is a wrapper for all other contexts
interface AppContextProviderProps {
  children: React.ReactNode;
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => {
  return (
    <AuthProvider>
      <TransactionProvider>
        <UIProvider>
          <NotificationProvider>
            <TrackingProvider>
              {children}
            </TrackingProvider>
          </NotificationProvider>
        </UIProvider>
      </TransactionProvider>
    </AuthProvider>
  );
};